
import React from 'react'
import { useState } from 'react'
import { createContext } from 'react'

export const ColorContext = createContext()

export const ColorContextProvider = ({ children }) => {
    const [colors, setColors] = useState('#0091EA')
    const [underLineColor,setUnderLineColor] = useState('black')
    const [textColor,setTextColor] = useState('black')
    const family = `system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;`
    return <ColorContext.Provider value={{ colors, setColors,underLineColor,setUnderLineColor,textColor,setTextColor,family }}>
        {children}
    </ColorContext.Provider>
}